// Import react and router-dom components
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

// Bulma Components
import {
  Container,
  Navbar,
  Form,
  Hero,
  Image,
  Columns,
  Icon as BIcon,
} from "react-bulma-components";

// Import images
import Logo from "../logo.png";

// MDI Icons
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";

// Utilised Short-handed Form Calls
const { Input, Control } = Form;

// Navbar Component
const NavbarFixedTop = () => {
  // search transition boolean
  const [searchTransition, setSearchTransition] = useState(false);

  // access router-dom variables
  let location = useLocation();
  let navigate = useNavigate();

  // When Enter key is pressed navigate to search result(s)
  const handleKeyUp = (e) => {
    if (e.key === "Enter") {
      navigate(`/search/${e.target.value}`);
      // console.log(e.target.value);
    }
  };

  // MouseEnter animation for search input
  const style = {
    paddingRight: "calc(calc(0.75em - 1px) + 17.375em)",
    transition: "padding-right 0.5s ease-out",
  };

  // MouseLeave animation for search input
  const closed = {
    paddingRight: "calc(calc(0.75em - 1px) + 0.375em)",
    transition: "padding-right 0.5s ease-in",
  };

  // onFocus and onBlur set transition state
  const handleSearchFocus = (e) => {
    setSearchTransition(!searchTransition);
  };

  return (
    <Navbar renderAs={Hero} color="link" fixed="top" gradient>
      <Container>
        {/* Logo */}
        <Navbar.Brand>
          <Navbar.Item renderAs={Link} to="/">
            <Image src={Logo}>Countries</Image>
          </Navbar.Item>
          <Navbar.Burger />
        </Navbar.Brand>

        {/* Search Input */}
        <Columns.Column pt="auto" renderAs={Navbar.Menu}>
          <Navbar.Container align="left">
            <Control>
              <Input
                type="text"
                mr="6"
                style={searchTransition ? style : closed}
                onKeyUp={handleKeyUp}
                onMouseEnter={handleSearchFocus}
                onMouseLeave={handleSearchFocus}
                placeholder="Search by country name & more"
                rounded={true}
              />
              <BIcon align="left">
                <Icon size={1} path={mdiMagnify} />
              </BIcon>
            </Control>
          </Navbar.Container>
        </Columns.Column>
        {/* Navbar */}
        <Navbar.Container align="right">
          {/* Check if the URL is equivalent to the following */}
          <Navbar.Item
            renderAs={Link}
            to="/"
            className={location.pathname === "/" ? "is-active" : ""}
          >
            Home
          </Navbar.Item>

          <Navbar.Item
            renderAs={Link}
            to="/region"
            className={location.pathname.includes("/region") ? "is-active" : ""}
          >
            Regions
          </Navbar.Item>
          <Navbar.Item
            renderAs={Link}
            to="/currency"
            className={
              location.pathname.includes("/currency") ? "is-active" : ""
            }
          >
            Currencies
          </Navbar.Item>
        </Navbar.Container>
      </Container>
    </Navbar>
  );
};

export default NavbarFixedTop;
